/* v8 ignore start */
import { type PropsWithChildren } from 'react';

import useAuthProvider from './useAuthProvider';

const AuthProvider = ({ children }: PropsWithChildren<{}>) => {
  useAuthProvider();

  return <>{children}</>;
};

export default AuthProvider;
/* v8 ignore end */
